export interface IconClassNames {
  filled: string;
  outline: string;
}

export const iconClassNames: IconClassNames = {
  filled: 'ui-icon__filled',
  outline: 'ui-icon__outline',
};
